import { Basket } from "../state/checkoutTypes"
import { LineItemInput } from "../types"

export interface AddToBasketHandler {
  inputItem: LineItemInput
  outputBasket: Basket
  addedCallback: () => void
  notAddedCallback: () => void
}

export const handleAddToBasketResult = (input: AddToBasketHandler) => {
  const { inputItem, outputBasket, addedCallback, notAddedCallback } = input
  const productInBasket = outputBasket?.items.find(
    (x) => x.variant?.info.variantId === inputItem.productVariant.info.variantId
  )
  if (!productInBasket || productInBasket.order.quantity === 0) {
    notAddedCallback()
  } else {
    addedCallback()
  }
}
